var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgUpgradeLock = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 16,
    viewBox: "0 0 12 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.96923 5.59903V3.9861C7.96923 2.76813 7.02308 1.77157 5.86667 1.77157C4.71025 1.77157 3.76411 2.7681 3.76411 3.9861V5.59903H2.08208V3.98613C2.08208 1.79377 3.78515 0 5.86667 0C7.94818 0 9.65125 1.79377 9.65125 3.98613V5.59903H7.96923ZM11.7333 7.81703V14.6153C11.7333 15.3769 11.1417 16 10.4187 16H1.31465C0.591594 16 0 15.3769 0 14.6153V7.817C0 7.05543 0.591594 6.43233 1.31465 6.43233H10.4187C11.1417 6.43233 11.7333 7.05547 11.7333 7.81703ZM6.97225 10.1534C6.97225 9.5103 6.47728 8.98893 5.86667 8.98893C5.25605 8.98893 4.76108 9.5103 4.76108 10.1534C4.76108 10.5491 4.94853 10.8986 5.23491 11.1091V12.7781C5.23491 13.1441 5.51917 13.4435 5.86667 13.4435C6.21416 13.4435 6.49842 13.1441 6.49842 12.7781V11.109C6.78484 10.8986 6.97225 10.5491 6.97225 10.1534Z",
    fill: "url(#paint0_linear_4270_7549)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4270_7549",
    x1: 2.15329,
    y1: 0.888889,
    x2: 11.6038,
    y2: 15.3831,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00D2A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#03C4DE"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgUpgradeLock);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/upgrade_lock.4d602b8ea6485606eb2975efdf2d87af.svg";